<template>
  <div class="FileComparisonComponent DataTables">

    
    <p v-if="!twoRevisionSelected">{{lang.infotext_2}}</p>  
    <p v-if="twoRevisionSelected">{{lang.infotext_1}}:</p>

    <div v-show="isData&&twoRevisionSelected" :id="id"></div>

      <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'FileComparisonComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'FileComparisonComponent',
        mainTable: "",
        id: "FileComparisonComponent" + this._uid,
        columns: [],
        colsAssign: [],
        files: [],
        isData: false

      }
  },
  computed: {
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    selectedRevisionRow(){
        return this.$store.getters.selectedRevisionRow;
    },
    twoRevisionSelected(){
        return this.$store.getters.selectedRevisionRow.length == 2;
    },
    revisionId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.id;
      
      
      
    },
       
    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    }

  },
  created () {

    this.createTable();


  },
  watch: {
    selectedRevisionRow: {
      handler: function(){
        
        this.createTable();
      },
      deep: true
    
      
    },
    
    reloadedAfterAction: function(newValue){

      if (newValue.name == this.name){
        if (newValue.status == true){
            
            this.createTable();
            
            newValue.status = false;
            newValue.name = "";
            this.$store.dispatch("reloadAfterAction", newValue);
        }
      }
    }
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable(){
      let vue = this;

      

      let arr = [];

      for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++){
          const obj = {
              revisionId: this.selectedRevisionRow[i].revisionId
          }
          arr.push(obj);
      }
         
      if (arr.length == 0){
        vue.isData = true; 
        return 
      }
      
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getFilesComparison", arr)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.files = result.data;
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
      
    },
    buildColumns(){

      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",
          type: "text"
        },
        // {
        //   name: this.lang.table_header_Revision,
        //   alignInColumn: "left",
        //   type: "text"
        // },
        {
          name: this.lang.table_header_Path,
          alignInColumn: "left",
          type: "text"
        },
        // {
        //   name: this.lang.table_header_Size,
        //   alignInColumn: "left",
        //   type: "taxt"
        // },
        // {
        //   name: this.lang.table_header_When,
        //   alignInColumn: "left",
        //   type: "text"
        // },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "guid" },
        { "data": "name" },
        // { "data": "fileRevision" },
        { "data": "folder" },
        //{ "data": "modificationDate"},
        { "data": "status"},
               
      ]

      this.buildTable();
    },
    buildTable(){
          
          var tableplace = document.getElementById(this.id);
          if (tableplace == null){
            return;
          }

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("style", "width:100%");
          table.setAttribute("class", "table table-striped table-bordered");
          tableplace.appendChild(table)

          var tr = document.createElement("tr");
          tr.setAttribute("class", "cellHeader");
          var thead = document.createElement("thead");
          thead.appendChild(tr);
          table.appendChild(thead);

          var vue = this;


          let columnDefs = [];
          var len = this.columns.length;
          for (var i = 0; i < len; i++){

            var el = {};

            var classname = '_dt-body-'+ this.columns[i].alignInColumn;

            el = {
              targets: i,
              className: classname,

              render: function ( data, type, row, meta ) {
                if (data == null) {
                  data = "";
                }

                data = $.fn.dataTable.render.text().display(data);
                if (data.display != undefined) {
                  data.display = $.fn.dataTable.render.text().display(data.display);
                }

                
                if (meta.col == 1){
                    let src = Tools.filenameToIcon(data);
                    
                    return "<img width=16px src=\"" + src + "\"> " + data;
                    
                    
                }
                if (meta.col == 2){
                    return data;
                }
                if (meta.col == 3){
                    let variant = "";
                    if (data == "new"){
                        variant = "success";
                    }
                    if (data == "deleted"){
                        variant = "danger";
                    }
                    if (data == "modified"){
                        variant = "warning";
                    }
                    
                    return "<b-badge class='badge badge-"+variant+"' >"+data+"</b-badge>";
                }

                return data;
              }


            }

            columnDefs.push(el);


            var th = document.createElement("th");
            tr.appendChild(th);
            //var p = document.createElement("p");
            //th.appendChild(p);
            var br = document.createElement("br");
            th.appendChild(br);
            var tx = document.createTextNode(this.columns[i].name)
            th.appendChild(tx);

          }


          var option = {};
          option.paging = true;
          option.info = true;
          option.dom = '<fr<t>ip>';
          option.data= this.files;
          option.myColumnFormats = this.columns;
          option.select = false;
          option.order = [[1, "asc"]];
          option.lengthMenu = [[20]];
          option.columns = this.colsAssign;

          option.columnDefs = columnDefs;
          option.initComplete = function () {


            console.log("complete")

          }




          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }

          var _vue = this;

          this.mainTable = $('#t_'+this.id).DataTable(option);

          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );

          let _mainTable = this.mainTable;

        

          //search input change view
          var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }
          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

        let download_buttons = document.getElementsByClassName('button-action-download');

        for (let i = 0, lei = download_buttons.length; i < lei; i++) {
            download_buttons[i].addEventListener('click', function (e){
            let id = this.id;
            let temp = id.split("_^_");
            
            

              const obj = {
                fileId: temp[1],
                revisionId: temp[3]
              }


               vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_downloadFile", obj)
               .then((result) =>{


                   console.log(result)
                   let fileName = temp[2];
        
                    var a = document.createElement("a");
                    a.href = URL.createObjectURL(result);
                    a.download = fileName;
                    
                    document.body.appendChild(a);
                    
                    a.click();
                    document.body.removeChild(a);
               })
                
            
            })
        }  
        },


  }
}
</script>


<style lang="scss">
  .FileComparisonComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
    .button-action-download{
      margin: 2px;
      padding: 0px 3px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/FileComparisonComponent.vue